import { keys } from "@/lib/i18n/portal";
import { ADMIN_ROLES } from "@/lib/auth/admin-roles";
import type { Tone } from "@/shared/rd";

/** Every role an admin can hold, in the order the form and the cards list them. */
export const ROLE_ORDER = [
  ADMIN_ROLES.SUPER_ADMIN,
  ADMIN_ROLES.ADMIN,
  ADMIN_ROLES.CUSTOMER_SERVICE,
  ADMIN_ROLES.SALES,
] as const;

/** Label key, tag tone and the one-line "what it unlocks" key per role. */
export const ROLE_META: Record<string, { label: string; tone: Tone; unlocks: string }> = {
  [ADMIN_ROLES.SUPER_ADMIN]: { label: keys.admin.roleSuperAdmin, tone: "purple", unlocks: "admin.roleUnlocksSuperAdmin" },
  [ADMIN_ROLES.ADMIN]: { label: keys.admin.roleAdmin, tone: "blue", unlocks: "admin.roleUnlocksAdmin" },
  [ADMIN_ROLES.CUSTOMER_SERVICE]: { label: keys.admin.roleCustomerService, tone: "green", unlocks: "admin.roleUnlocksCustomerService" },
  [ADMIN_ROLES.SALES]: { label: keys.admin.roleSales, tone: "amber", unlocks: "admin.roleUnlocksSales" },
};

/** Avatar tints, picked by the admin's position so neighbours differ. */
export const AVATAR_TINTS = [
  "var(--rd-purple-tag)",
  "var(--rd-blue-tag)",
  "var(--rd-green-tag)",
  "var(--rd-amber-tag)",
  "var(--rd-pink-tag)",
];

export function initialsOf(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0] ?? "")
    .join("")
    .toUpperCase();
}
